import { Id, withIndexEndpoint } from "@dgs/core";
import { ContactEventIndexResource } from "../types";

export const eventContactBaseKey = (contactId: Id) => ["contacts", `${contactId}`, "events"];

export const createEventContactService = (contactId: Id) => {
	return {
		...withIndexEndpoint<ContactEventIndexResource>(eventContactBaseKey(contactId)),
	};
};
